import { useEffect } from 'react';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { LabelV2VersionDetailsFormComponentProps } from './types';
import { useLabelV2VersionDetails } from './hooks';
import { LabelV2VersionDetailsForm } from './LabelV2VersionDetailsForm';
import { ReleaseActions } from '../ReleaseActions';

export const LabelV2VersionDetailsComponent = (
  props: LabelV2VersionDetailsFormComponentProps
) => {
  const {
    isSyncing,
    primaryAudio,
    fetchAudioDetailsValidations,
    updateAudioValidations,
  } = props;
  const formProps = useLabelV2VersionDetails(props);

  useEffect(() => {
    if (!updateAudioValidations && primaryAudio?.audioData.guid) {
      fetchAudioDetailsValidations(primaryAudio.audioData.guid);
    }
  }, [updateAudioValidations, primaryAudio, fetchAudioDetailsValidations]);

  return (
    <ContentContainer type={ContentContainerType.LIST} pb={24}>
      <ReleaseActions tab="details" syncState={isSyncing} />
      <LabelV2VersionDetailsForm {...formProps} />
    </ContentContainer>
  );
};
